(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lottie-motion"] && !Shopify.designMode) return;
  try {
    const header = document.querySelector('[data-ll-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const burger = header.querySelector('[data-ll-burger]');
    const nav = header.querySelector('[data-ll-nav]');
    if (burger && nav) {
      burger.addEventListener('click', () => {
        const open = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  const stage = document.querySelector('[data-ll-stage]');
  const stageInner = document.querySelector('[data-ll-stage-inner]');
  if (stage && stageInner) {
    stage.addEventListener('mousemove', (event) => {
      const rect = stage.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      stageInner.style.transform = `rotateY(${x * 16}deg) rotateX(${-y * 14}deg) translateZ(20px)`;
    });
    stage.addEventListener('mouseleave', () => {
      stageInner.style.transform = '';
    });
  }

  document.querySelectorAll('[data-ll-tilt]').forEach((card) => {
    card.addEventListener('mousemove', (event) => {
      const rect = card.getBoundingClientRect();
      const px = (event.clientX - rect.left) / rect.width;
      const py = (event.clientY - rect.top) / rect.height;
      card.style.transform = `rotateY(${(px - 0.5) * 13}deg) rotateX(${(0.5 - py) * 13}deg) translateY(-8px)`;
      card.style.setProperty('--mx', `${px * 100}%`);
      card.style.setProperty('--my', `${py * 100}%`);
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });

  const nookScene = document.querySelector('[data-ll-nook-scene]');
  const nookBox = document.querySelector('[data-ll-nook-box]');
  if (nookScene && nookBox) {
    nookScene.addEventListener('mousemove', (event) => {
      const rect = nookScene.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      nookBox.style.transform = `rotateY(${-24 + x * 34}deg) rotateX(${6 - y * 20}deg)`;
    });
    nookScene.addEventListener('mouseleave', () => {
      nookBox.style.transform = 'rotateY(-24deg) rotateX(6deg)';
    });
  }

  const nameInput = document.querySelector('[data-ll-name]');
  const engrave = document.querySelector('[data-ll-engrave]');
  const engraveProp = document.querySelector('[data-ll-engrave-prop]');
  const finishProp = document.querySelector('[data-ll-finish-prop]');
  if (nameInput && engrave) {
    nameInput.addEventListener('input', () => {
      const value = nameInput.value.trim() || 'Your name';
      engrave.textContent = value;
      if (engraveProp) engraveProp.value = value;
      engrave.style.transform = 'scale(1.06)';
      window.setTimeout(() => {
        engrave.style.transform = 'scale(1)';
      }, 180);
    });
  }

  document.querySelectorAll('[data-ll-chip]').forEach((chip) => {
    chip.addEventListener('click', () => {
      document.querySelectorAll('[data-ll-chip]').forEach((item) => item.classList.remove('is-on'));
      chip.classList.add('is-on');
      if (engrave) engrave.style.color = chip.dataset.color;
      if (finishProp) finishProp.value = chip.dataset.finish;
    });
  });

  const reveal = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (!entry.isIntersecting) return;
      window.setTimeout(() => entry.target.classList.add('is-in'), index * 70);
      reveal.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px' });

  document.querySelectorAll('.ll-rv').forEach((element) => reveal.observe(element));
  } catch(e) { console.error(e); }
})();

})();
